.accommodationBlockingFormPage {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 900px;
}

.heading {
  margin: 0;
}

.recordId {
  font-weight: 400;
  color: var(--text-color-secondary, #6c757d);
}

.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem 0;
}

.error {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: flex-start;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.radioGroupLabel {
  font-weight: 600;
}

.actions {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
}
